import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { LessonsCountByType } from '../../../typings';

export function getLessonsCount(courseId: number): Promise<LessonsCountByType> {
    const { apiGetLessonsCount } = apiConfig.getStaticUrls();

    //@ts-ignore
    return getFetch(`${apiGetLessonsCount}${courseId}/`);
}
